import React from 'react';

import UI from '#front-credpago';

import useResizer from '../../../utils/useResizer';
import * as S from './styles';

const StartOurStory = ({ data }) => {
  const isMobile = useResizer();

  if (isMobile) {
    return (
      <>
        <S.FullWidthWrapper>
          <S.Container>
            <UI.Row>
              <UI.Col responsive={{ xs: 12, md: 6 }}>
                <S.WrapperImg>
                  <S.ImgHand fluid={data.Hand.childImageSharp.fluid} />
                </S.WrapperImg>
              </UI.Col>
            </UI.Row>
          </S.Container>
        </S.FullWidthWrapper>

        <S.Container>
          <UI.Row>
            <UI.Col style={{ alignSelf: 'center' }} responsive={{ xs: 12, md: 6 }}>
              <UI.Title level={1} fontWeight={700} splitLabel={['Muito além de uma', 'garantia para aluguel']} />

              <UI.Description color="gray" style={{ marginTop: 20, textAlign: 'left' }}>
                Chegamos em 2016 rompendo barreiras no mercado de locação de imóveis, diminuindo custos e eliminando
                processos burocráticos. Baixamos a régua de preços das garantias pagas, o que trouxe mais liberdade para
                quem quer alugar sem precisar de fiador.
              </UI.Description>
            </UI.Col>
          </UI.Row>
        </S.Container>
      </>
    );
  }

  return (
    <S.FullWidthWrapper smallOnMdScreen={true}>
      <S.Container>
        <UI.Row>
          <UI.Col style={{ alignSelf: 'center' }} responsive={{ xs: 12, md: 7, lg: 7 }} className="text-wrapper">
            <UI.Title level={1} fontWeight={700} splitLabel={['Muito além de uma', 'garantia para aluguel']} />

            <UI.Description color="gray" style={{ marginTop: 20, textAlign: 'left', maxWidth: 550 }}>
              Chegamos em 2016 rompendo barreiras no mercado de locação de imóveis, diminuindo custos e eliminando
              processos burocráticos. Baixamos a régua de preços das garantias pagas, o que trouxe mais liberdade para
              quem quer alugar sem precisar de fiador.
            </UI.Description>
          </UI.Col>
          <UI.Col responsive={{ xs: 12, md: 5, lg: 5 }}>
            <S.WrapperImg>
              <S.ImgHand fluid={data.Hand.childImageSharp.fluid} />
            </S.WrapperImg>
          </UI.Col>
        </UI.Row>
      </S.Container>
    </S.FullWidthWrapper>
  );
};

export default StartOurStory;
